var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 28",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.8502V24.4502C25 22.8589 24.3679 21.3328 23.2426 20.2076C22.1174 19.0823 20.5913 18.4502 19 18.4502H7C5.4087 18.4502 3.88258 19.0823 2.75736 20.2076C1.63214 21.3328 1 22.8589 1 24.4502V29.8502",
    stroke: "inherit",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.6504C16.3137 13.6504 19 10.9641 19 7.65039C19 4.33668 16.3137 1.65039 13 1.65039C9.68629 1.65039 7 4.33668 7 7.65039C7 10.9641 9.68629 13.6504 13 13.6504Z",
    stroke: "inherit",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.81e97b99.svg";
export { ForwardRef as ReactComponent };